<app-news
[preload]="true"
[topic]="topic"
[source]="source"
[writer]="writer"
[showDetail]="false"
[loading]="loading"
[showViews]="false"
[showMap]="false"
[showRelated]="false"
[showComment]="true"
[images]="[images]"
[comments]="comments"></app-news>


<div class="post-analysis">
  <div class="post-analysis-header">
    <div class="post-analysis-title">Post Analysis</div>
  </div>
  <div class="line"></div>
  <div class="sentiment">
    <div class="sentiment-image-container">
      <img [src]="getSentimentImageSrc()" alt="Sentiment Analysis">
      <span class="sentiment-text">{{ Score }}</span>
    </div>
  </div>
  <div class="stats">
    <div class="stat-item">
      <div class="stat-label-header">
        <span class="stat-label">Comment</span>
      </div>
      <strong>{{ Comment_Count }}</strong>
    </div>
    <div class="stat-item">
      <div class="stat-label-header">
      <span class="stat-label">Reaction</span>
    </div>
      <strong>{{ Reaction_Count }}</strong>
    </div>
    <div class="stat-item">
      <div class="stat-label-header">
      <span class="stat-label">Engagement</span>
    </div>
      <strong>{{ Engagement }}%</strong>
    </div>
  </div>
  <div class="keywords">
    <h3>Top Keywords</h3>
    <ol>
      <li>Word</li>
      <li>Word</li>
      <li>Word</li>
    </ol>
  </div>
</div>